import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.clickOutsideHandler = (event) => {
      if (this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")) {
        if (!this.menuTarget.contains(event.target) && !event.target.closest(".category-menu-trigger")) {
          this.close()
        }
      }
    }
    document.addEventListener("click", this.clickOutsideHandler)

    this.scrollHandler = () => this.close()
    window.addEventListener("scroll", this.scrollHandler, true)

    const scrollParent = document.querySelector(".overflow-x-auto")
    if (scrollParent) {
      scrollParent.addEventListener("scroll", this.scrollHandler)
    }
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler)
    window.removeEventListener("scroll", this.scrollHandler, true)
    const scrollParent = document.querySelector(".overflow-x-auto")
    if (scrollParent) {
      scrollParent.removeEventListener("scroll", this.scrollHandler)
    }
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const menu = this.menuTarget

    if (!menu.classList.contains("hidden") && this.activeButton === button) {
      this.close()
      return
    }

    this.activeButton = button

    const categoryId = button.dataset.categoryId
    const categoryName = button.dataset.categoryName
    const isMobile = button.dataset.isMobile === "true"
    const locale = new URLSearchParams(window.location.search).get("locale") || ""
    const localeParam = locale ? `locale=${locale}` : ""

    const editLink = menu.querySelector("#category-menu-edit")
    if (editLink) {
      editLink.href = `/categories/${categoryId}/edit?${localeParam}`
    }

    const deleteForm = menu.querySelector("#category-menu-delete-form")
    if (deleteForm) {
      const formElement = deleteForm.tagName === "FORM" ? deleteForm : (deleteForm.form || deleteForm.closest("form"))
      if (formElement) {
        formElement.action = `/categories/${categoryId}?${localeParam}`
      }
    }

    const viewIssueContainer = menu.querySelector("#category-menu-view-issue-container")
    const viewIssueLink = menu.querySelector("#category-menu-view-issue")
    if (viewIssueLink) {
      viewIssueLink.href = `/categories/${categoryId}?${localeParam}`
      if (isMobile) {
        viewIssueContainer?.classList.remove("hidden")
      } else {
        viewIssueContainer?.classList.add("hidden")
      }
    }

    const projectId = button.dataset.projectId
    const parentId = button.dataset.parentId
    const addSubContainer = menu.querySelector("#category-menu-add-sub-container")
    const addSubLink = menu.querySelector("#category-menu-add-sub")

    if (addSubLink) {
      if (parentId) {
        addSubContainer?.classList.add("hidden")
      } else {
        addSubContainer?.classList.remove("hidden")
        addSubLink.href = `/projects/${projectId}/categories/new?parent_id=${categoryId}&${localeParam}`
      }
    }

    const rect = button.getBoundingClientRect()

    menu.style.visibility = "hidden"
    menu.classList.remove("hidden")
    const menuWidth = menu.offsetWidth
    const menuHeight = menu.offsetHeight
    menu.classList.add("hidden")
    menu.style.visibility = ""

    let top = rect.bottom + 4
    let left = rect.right - menuWidth

    if (top + menuHeight > window.innerHeight) {
      top = rect.top - menuHeight - 4
    }
    if (left < 8) {
      left = 8
    }

    menu.style.top = `${top}px`
    menu.style.left = `${left}px`
    menu.classList.remove("hidden")
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
      this.activeButton = null
    }
  }
}
